import {ImageUploader} from '@/containers/ClubPlus/CreateTier/phases/Display/ImageUploader'
import {Divider} from '@/components/atoms'
import {useFormContext} from 'react-hook-form'
import {Font, Icon} from 'pepsico-ds'
import {useIntl} from 'react-intl'
import {useEffect} from 'react'
import FormInputController from '@/components/molecules/FormInputController'

export const DisplayForm = ({language, tierData}) => {
  const {control, getValues, setValue} = useFormContext()
  const {formatMessage} = useIntl()

  const handleFieldChange = field => value => {
    field.onChange(value)
  }

  const getImageData = (imageType) => {
    const content = tierData?.content?.[language]
    if (!content) return null

    const imageMap = {
      imageTierIcon: content.imageTierIconObject?.data,
      bannerImage: content.bannerImageObject?.data,
      detailsImage: content.detailsImageObject?.data,
    }

    return imageMap[imageType] || null
  }

  const getImageUploadLabel = (label) => {
    return (
      <span className= "flex gap-2">
        {formatMessage({id: label})}
        <Icon icon="info" size="small" />
      </span>
    )
  }

  useEffect(() => {
    const values = getValues()
    setValue(`content.${language}.tierName`, values.name)
  }, [getValues, language, setValue])

  return (
    <>
      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({id: 'CLUB_PLUS.TIER_CREATE_HOMEPAGE_TITLE'})}
        </Font>
      </div>
      <div className="flex w-full justify-start gap-6">
        <ImageUploader
          control={control}
          name={`content.${language}.imageTierIcon`}
          label={ getImageUploadLabel('CLUB_PLUS.TIER_CREATE_FORM_TIER_NAME_LABEL')}
          initialImageData={getImageData('imageTierIcon')}
        />
        <div>
          <Font  variant="regular" size="xsmall" textColorClass="text-white">
            {formatMessage({id: 'CLUB_PLUS.TIER_CREATE_TIER_LABEL'})}
          </Font>
          <FormInputController
            onChange={handleFieldChange}
            name={`content.${language}.tierName`}
            inputType="text"
            labelText="CLUB_PLUS.TIER_CREATE_TIER_LABEL"
            placeholderText="CLUB_PLUS.TIER_CREATE_NAME_PLACEHOLDER"
            fieldProps={{disabled: true, visible: true}}
            hideLabel
          />
          <FormInputController
            onChange={handleFieldChange}
            name={`content.${language}.displayDescription`}
            inputType="text"
            labelText="CLUB_PLUS.TIER_CREATE_FORM_DISPLAY_DESCRIPTION_INPUT_LABEL"
            helperText="CLUB_PLUS.TIER_CREATE_FORM_HELPER_TEXT"
            placeholderText="CLUB_PLUS.TIER_CREATE_FORM_DISPLAY_DESCRIPTION_PLACEHOLDER"
            fieldProps={{visible: true}}
            hideLabel={false}
            maxLength={30}
          />
        </div>
      </div>
      <Divider />
      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({id: 'CLUB_PLUS.TIER_CREATE_DETAIL_BANNER'})}
        </Font>
      </div>
      <div className="tier-display-form flex w-full justify-start gap-6">
        <ImageUploader
          control={control}
          name={`content.${language}.bannerImage`}
          label={getImageUploadLabel('CLUB_PLUS.TIER_CREATE_FORM_HOMEPAGE_IMAGE')}
          initialImageData={getImageData('bannerImage')}
        />
        <div className="flex flex-col gap-3">
          <FormInputController
            onChange={handleFieldChange}
            name={`content.${language}.bannerHeader`}
            inputType="textarea"
            labelText="CLUB_PLUS.TIER_CREATE_FORM_BANNER_HEADER_LABEL"
            helperText="CLUB_PLUS.TIER_CREATE_TEXTAREA_HELPER_TEXT"
            placeholderText="CLUB_PLUS.TIER_CREATE_FORM_BANNER_HEADER_PLACEHOLDER"
          />
          <FormInputController
            onChange={handleFieldChange}
            name={`content.${language}.bannerDescription`}
            inputType="textarea"
            labelText="CLUB_PLUS.TIER_CREATE_REVIEW_DESCRIPTION_LABEL"
            helperText="CLUB_PLUS.TIER_CREATE_TEXTAREA_HELPER_TEXT"
            placeholderText="CLUB_PLUS.TIER_CREATE_REVIEW_DESCRIPTION_LABEL"
          />
        </div>
      </div>
      <Divider />
      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({id: 'CLUB_PLUS.TIER_CREATE_DETAIL_PAGE'})}
        </Font>
      </div>
      <div className="tier-display-form flex w-full justify-start gap-6">
        <ImageUploader
          control={control}
          name={`content.${language}.detailsImage`}
          label={getImageUploadLabel('CLUB_PLUS.TIER_CREATE_FORM_DETAIL_PAGE_IMG')}
          initialImageData={getImageData('detailsImage')}
        />
        <div className="flex flex-col gap-3">
          <FormInputController
            onChange={handleFieldChange}
            name={`content.${language}.detailsDescription`}
            inputType="textarea"
            labelText="CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_LABEL"
            helperText="CLUB_PLUS.TIER_CREATE_TEXTAREA_HELPER_TEXT"
            placeholderText="CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_PLACEHOLDER"
          />
          <FormInputController
            onChange={handleFieldChange}
            name={`content.${language}.detailsTermsAndConditions`}
            inputType="textarea"
            labelText="CLUB_PLUS.TIER_CREATE_FORM_TERMS_CONDITIONS_LABEL"
            helperText="CLUB_PLUS.TIER_CREATE_TEXTAREA_HELPER_TEXT"
            placeholderText="CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_PLACEHOLDER"
          />
        </div>
      </div>
      <Divider />
      <div className="pb-28"></div>
    </>
  )
}
